







































# import settings from '@/settings'
import formations_table from '@/components/tables/formations_table'
import Menus from '@/components/menus'
import m from '@/graphql/mutation'
import n from '@/utils/notifications'
import t from '@/utils/tools'

export default {
    name: 'company_formations'

    components: { formations_table, Menus }

    data: ()->
        refuse_dialog_visible: false
        accept_dialog_visible: false
        reload: false
        unity_options: @$store.state.unity_options
        formation: {
            uid: ''
            user_in_charge_uid: ''
            formation_type: {uid: '', label: ''}
            start: ''
            end: ''
            state: {uid: ''}
            reason: ''
            program: ''
            program_dir: ''
            name: ''
            location: ''
            organization: ''
            funding: {uid: ''}
            duration: 0
            duration_unity: 1
        }
        errors: {}
        valid_text: {
            title: ''
            resume: ''
            confirm: ''
        }
        refuse_text: ''

    methods:
        date_formatter: t.date_formatter

        valid_text_factory: (old_state_slug)->
            # console.log "VALID TEXT ", old_state_slug
            ret = {
                title: "Validation d'une demande de formation"
                resume: "la demande"
                confirm: "la demande"
            }
            if old_state_slug == 'annulation_demandee'
                ret = {
                    title: "Annulation d'une formation"
                    resume: "la formation"
                    confirm: "l'annulation"
                }
            @valid_text = ret
            return

        refuse_text_factory: (old_state_slug)->
            # console.log "REFUSE TEXT ", old_state_slug
            ret = "d'une demande de formation"
            if old_state_slug == 'annulation_demandee'
                ret = "d'une annulation"
            @refuse_text = ret
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        refuse_open_confirm: (formation, old_state_slug)->
            @refuse_dialog_visible = true
            @formation = formation
            @refuse_text_factory(old_state_slug)
            # console.log 'OPEN CONFIRM'
            return

        accept_open_confirm: (formation, old_state_slug)->
            @accept_dialog_visible = true
            @formation = formation
            @valid_text_factory(old_state_slug)
            # console.log 'OPEN CONFIRM'
            return

        refuse_cancel: ()->
            @refuse_dialog_visible = false
            @reload = !@reload
            @errors = {}
            # console.log 'REFUSE CANCEL'
            return

        accept_cancel: ()->
            @accept_dialog_visible = false
            @reload = !@reload
            @errors = {}
            # console.log 'ACCEPT CANCEL'
            return

        pre_save: ()->
            @save(@formation)
            return

        save: (formation)->
            # console.log "SAVE FORMATION", formation
            self = @
            m.run('save_formation', [formation, 'company'])
            .then (resp)->
                if resp.body.data.formation_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.formation_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.formation_form_mutation.errors
                    self.errors = resp.body.data.formation_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.accept_dialog_visible = false
                    self.refuse_dialog_visible = false
                    self.formation = {
                        uid: ''
                        user_in_charge_uid: ''
                        formation_type: {uid: '', label: ''}
                        start: ''
                        end: ''
                        state: {uid: ''}
                        reason: ''
                        program: ''
                        program_dir: ''
                        name: ''
                        location: ''
                        organization: ''
                        funding: {uid: ''}
                        duration: 0
                        duration_unity: 1
                    }
                    self.reload = !self.reload
            .catch (resp)->
                n.catch_error(resp, "company_formations: save()")
}
